export default {
    title: "Importações de Histórico",
    startDateLabel: "Data inicial",
    endDateLabel: "Data final",
    startImportButton: "Começar importação",
    applyLabel: "Aplicar",
    cancelLabel: "Cancelar",
    startSuccessNotification: "Importação de histórico iniciada com sucesso",
    confirmTitle: "Tem certeza?",
    confirmPrefix: "Você irá",
    confirmHighlight: "cancelar essa importação de histórico",
    confirmIrreversible: "Essa ação NÃO é reversível.",
    columnId: "ID",
    columnStartDate: "Data Inicial",
    columnEndDate: "Data Final",
    columnLastImportedDate: "Última Data Importada",
    columnStatus: "Status",
    columnImportedDays: "Dias importados",
    columnRemainingDays: "Dias faltando",
    columnProgress: "Progresso",
    columnActions: "Ações",
    noImportPerformed: "Nenhuma importação realizada",
    cancelButton: "Cancelar",
    cancelSuccessNotification: "Importação de Histórico cancelada",
    cancelErrorNotification: "Erro ao cancelar importação",
    statusComplete: "Completo",
    statusCancelled: "Cancelado",
    statusInProgress: "Processando",
    statusPending: "Pendente",
    statusFailed: "Falhou",
    daySun: "Dom",
    dayMon: "Seg",
    dayTue: "Ter",
    dayWed: "Qua",
    dayThu: "Qui",
    dayFri: "Sex",
    daySat: "Sab",
    monthJan: "Jan",
    monthFeb: "Fev",
    monthMar: "Mar",
    monthApr: "Abr",
    monthMay: "Mai",
    monthJun: "Jun",
    monthJul: "Jul",
    monthAug: "Ago",
    monthSep: "Set",
    monthOct: "Out",
    monthNov: "Nov",
    monthDec: "Dez",
};
